// components/Modals/RenewSubscriptionModal.jsx
import React from "react";
import BaseModal from "./BaseModal";
import { AlertCircle } from "lucide-react";

const RenewSubscriptionModal = ({ open, onClose, onConfirm }) => {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className="p-6 text-center space-y-4">
        <div className="mx-auto h-14 w-14 rounded-full bg-[#FFEFEB] flex items-center justify-center">
          <AlertCircle className="text-[#FF6943]" size={28} />
        </div>

        <h2 className="text-[#FF6943] font-semibold">
          Are you sure you want to renew your subscription?
        </h2>

        <p className="text-sm text-gray-500">
          Your upcoming plan will automatically continue with the same meal
          details.
        </p>

        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="flex-1 py-2 rounded-full border border-[#FF6943] text-[#FF6943]"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 py-2 rounded-full bg-[#FF6943] text-white"
          >
            Renew
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default RenewSubscriptionModal;
